import { Component } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AdditionalItemMasterRepository } from "../models/additionalItemMaster.repository";
import { AdditionalItemMaster } from "../models/additionalItemMaster.model";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AdditionalItemMasterModalComponent } from './additionalItemMasterModal.component';

@Component({
  templateUrl: "additionalItemMaster.component.html",
  styleUrls: ['additionalItemMaster.component.css']
})
export class AdditionalItemMasterComponent {
  constructor(private repo: AdditionalItemMasterRepository, public dialog: MatDialog) {
    this.repo.getAdditionalItemMasters();
  }

  get additionalItemMasters() {
    return this.repo.additionalItemMasters;
  }

  drop(event: CdkDragDrop<string[]>) {
    let allItems = this.repo.additionalItemMasters
    const from = event.previousIndex;
    const to = event.currentIndex;
    const current = allItems[from];
    moveItemInArray(allItems, from, to);

    // Computing a new orderValue for the object that was moved
    let lowerBound = 0.0;
    // Is there an object before it in the array?
    if (to > 0) {
      lowerBound = allItems[to - 1].order;
    } else {
      lowerBound = allItems[1].order - 2.0;
    }
    let upperBound = 0.0;
    // Is there an object after it in the array?
    if (to < allItems.length - 1) {
      upperBound = allItems[to + 1].order;
    } else {
      upperBound = allItems[to - 1].order + 2.0;
    }
    const newOrderValue = (lowerBound + upperBound) / 2.0;
  
    current.order = newOrderValue;
    this.repo.replaceAdditionalItemMaster(current)
      .subscribe(() => this.repo.getAdditionalItemMasters());
  }

  add() {
    const ref: MatDialogRef<AdditionalItemMasterModalComponent> = this.dialog.
      open(AdditionalItemMasterModalComponent, {
        data: new AdditionalItemMaster(0, "", null, "", true, 0),
        width: "600px",
        height: "500px",
        hasBackdrop: true
      });
  }

  edit(additionalItemMaster: AdditionalItemMaster) {
    const ref: MatDialogRef<AdditionalItemMasterModalComponent> = this.dialog.
      open(AdditionalItemMasterModalComponent, {
        data: additionalItemMaster,
        width: "600px",
        height: "500px",
        hasBackdrop: true
      });
  }

  remove(additionalItemMaster: AdditionalItemMaster) {
    const details = this.repo.additionalItemMasters;
    const index = details.indexOf(additionalItemMaster);
    if (index > -1) {
      this.repo.deleteAdditionalItemMaster(additionalItemMaster).subscribe(() => this.repo.getAdditionalItemMasters());
    }
  }
}
